import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { CalculationQueueItemDto } from 'src/app/server-api/models';
import { CalculationQueueItemControllerService } from 'src/app/server-api/services';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';


@Component({
  selector: 'app-recalculate-queue',
  templateUrl: './recalculate-queue.component.html',
  styleUrls: ['./recalculate-queue.component.css']
})
export class RecalculateQueueComponent extends DetailComponent {
  queue: CalculationQueueItemDto[];
  interval:any;
    
  //put in something dummy
  @Input() override id: string = 'dummy';

  constructor(
    public override translate: TranslateService,
    private queueService: CalculationQueueItemControllerService,
    public override sidenavService: SideNavService,
    public override router: Router
  ) {
    super(translate, sidenavService, router);
  }

  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.queue = {} as any as CalculationQueueItemDto[];

    this.initForm();
    this.columnsVisible.set('id', false);
  }

  override ngOnInit(): void {
      super.ngOnInit();

      //refresh every 5 seconds
      this.interval = setInterval(()=>{
          this.refresh();
        },5000);
      
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    clearInterval(this.interval);
  }
  
  override getItem(request) {
    super.getItem(request);

   this.queueService.getQueue(request).subscribe((data: CalculationQueueItemDto[]) => {
      this.queue = data;
        
      this.initForm();    
    });
  }
  
  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    this.columnsVisible = new Map([
      
      ]);
  
  }

  override initForm() {
    super.initForm();
    this.initDialogDelete('stress-area.dialog_title');

    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu']).subscribe((translations: string) => {
      this.topMenuIcons = [
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
        }
      ];
    });
    this.setForm();
  }

  
  override saveOk() {
    super.saveOk();
    this.sidenavService.setLoading(false);
    //no save done
  }


  override delete() {
    super.delete();
    this.sidenavService.setLoading(false);
    //no delete done
  }
}

  

